import React from "react";

function NotFound() {
  return <div style={{ height: 3000, textAlign: "center" }}>404</div>;
}

export default NotFound;
